import React, { useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions, selectors } from 'farmx-redux-core';
import PropTypes from 'prop-types';
import { Tag, Select } from 'antd';
import ItemSelect from './ItemSelect';
import BlockOption from './BlockOption';
import DropdownModal from './sensor/DropdownModal';
import SensorSelectContext from './sensor/SensorSelectContext';
import styles from './CommonStyle.less';

const mobileScreen = window.innerWidth < 599;

const { Option } = Select;

const {
  loadFarmData,
} = actions;

const {
  selectAllBlocks,
} = selectors;

const blockTagRender = (args) => {
  const {
    closable, onClose, label,
  } = args;
  return (
    <Tag
      closable={closable}
      onClose={onClose}
      className={styles['block-select-tag']}
    >
      {label.props ? label.props.block.name : label}
    </Tag>
  );
};

const defaultItemRenderer = (d) => (
  <Option
    className={styles['add-color-to-even-rows']}
    key={d.id}
    value={d.id}
    label={d.name}
    data-testid={`${d.name}`}
  >
    <BlockOption block={d} />
  </Option>
);

const BlockSelect = ({
  loadItems,
  items,
  mode,
  renderItem,
  onSelect,
  onChange,
  tagRender,
  placeholder,
  defaultOption,
  value,
  bordered,
  title,
  applyFilter,
}) => {
  const dispatch = useDispatch();
  const data = useSelector(selectAllBlocks);
  const blocks = items || data;
  const [modal, setModalState] = useState(false);
  const [searchText, setSearchText] = useState('');
  const dropdownStyleValues = useContext(SensorSelectContext);

  useEffect(() => {
    if (loadItems) loadItems();
    else dispatch(loadFarmData(applyFilter));
  }, [applyFilter, dispatch, loadItems]);

  let dropdownStyle = null;
  if (window.innerWidth < 599) dropdownStyle = { minWidth: '60%' };

  function onSelectAction(d) {
    if (onSelect) onSelect(d);
    if (!mobileScreen) {
      setModalState(false);
    }
  }

  function customFilterMobile(searchStr) {
    const filterResult = blocks.filter((d) => ((d && d.name
      && d.name.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0)
      || (d && d.ranch && d.ranch.name.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0)));
    return filterResult;
  }

  return (
    <ItemSelect
      mode={mode}
      renderItem={renderItem}
      items={!mobileScreen ? blocks : customFilterMobile(searchText)}
      onSelect={onSelectAction}
      onChange={onChange}
      tagRender={tagRender || blockTagRender}
      placeholder={placeholder}
      defaultOption={defaultOption}
      value={value}
      filterOption={(input, option) => option.children.props.block.name.toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
        || (option.children.props.block.ranch
          && option.children.props.block.ranch.name
            .toLowerCase().indexOf(input.toLowerCase()) >= 0)}
      dropdownStyle={dropdownStyle}
      menuIsOpen={mobileScreen ? modal : undefined}
      dropdownRender={mobileScreen ? (menu) => (
        <DropdownModal
          title={title}
          displayOptions={menu}
          mobileScreen={mobileScreen}
          onClick={() => setModalState(false)}
          onChange={(d) => setSearchText(d.target.value)}
          displaySearch
          size={mobileScreen ? 'large' : 'middle'}
        />
      ) : undefined}
      dropdownStyleValues={dropdownStyleValues}
      onDropdownVisibleChange={mobileScreen ? () => setModalState(true) : undefined}
      showSearch={!mobileScreen}
      bordered={bordered}
    />
  );
};

BlockSelect.propTypes = {
  mode: PropTypes.string,
  loadItems: PropTypes.func,
  renderItem: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  tagRender: PropTypes.func,
  placeholder: PropTypes.string,
  defaultOption: PropTypes.arrayOf(PropTypes.any),
  value: PropTypes.arrayOf(PropTypes.any),
  bordered: PropTypes.bool,
  title: PropTypes.string,
  applyFilter: PropTypes.bool,
};

BlockSelect.defaultProps = {
  mode: null,
  loadItems: null,
  items: null,
  renderItem: defaultItemRenderer,
  onSelect: null,
  onChange: null,
  tagRender: null,
  placeholder: null,
  defaultOption: [],
  value: null,
  bordered: true,
  title: 'Block Select',
  applyFilter: true,
};

export default BlockSelect;
